import React from 'react';

/**
 * The change-request form. Extracted from EpisodeReview 18 Sep 2026.
 *
 * Timecode is optional and deliberately free text — a client writing "00:17"
 * or "17s" or "the bit with the logo" is all useful, and a picker that
 * insisted on a format would lose the third one entirely.
 */
interface ChangeComposerProps {
  timecode: string;
  setTimecode: (next: string) => void;
  changeNote: string;
  setChangeNote: (next: string) => void;
  onSubmit: (event: React.FormEvent) => void;
  onDone: () => void;
}
export function ChangeComposer({
  timecode,
  setTimecode,
  changeNote,
  setChangeNote,
  onSubmit,
  onDone
}: ChangeComposerProps) {
  return <form onSubmit={onSubmit} className="mt-8 border border-ink px-7 py-9 sm:px-10" data-id="element-29" data-mp="kwusixh9ou74">
      <h2 className="font-display text-2xl leading-tight sm:text-3xl" data-id="element-30" data-mp="fytamfvkv0x8">
        What would you like us to change?
      </h2>
      <div className="mt-8 flex flex-col gap-8 sm:flex-row sm:items-start" data-id="element-31" data-mp="1rf9v4nlzo7qy">
        <label className="sm:w-32" data-id="element-32" data-mp="1rhdvwwolcqn0">
          <span className="label block text-graphite" data-id="element-33" data-mp="1lrjw64rjntcl">Timecode</span>
          <input value={timecode} onChange={event => setTimecode(event.target.value)} placeholder="e.g. 00:17" inputMode="numeric" className="mt-4 w-full border-0 border-b border-rule bg-transparent pb-3 font-display text-xl text-ink placeholder:text-mute focus:border-ink focus:outline-none" data-id="element-34" data-mp="1ltecf5rvexac" />
        </label>
        <label className="flex-1" data-id="element-35" data-mp="132n3u6fpjax0">
          <span className="label block text-graphite" data-id="element-36" data-mp="17zwsvkz6pkkb">Change Request</span>
          <textarea value={changeNote} onChange={event => setChangeNote(event.target.value)} rows={3} placeholder="Describe the change required…" className="mt-4 w-full resize-none border-0 border-b border-rule bg-transparent pb-3 font-display text-xl text-ink placeholder:text-mute focus:border-ink focus:outline-none" data-id="element-37" data-mp="17xspr5940pl3" />
        </label>
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-38" data-mp="1rmtmwwg0obp4">
        <button type="submit" className="label border border-ink px-7 py-4 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-39" data-mp="1rkz2dj8nqllk">
          Add Change
        </button>
        <button type="button" onClick={onDone} className="label text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-40" data-mp="21epls9pxg5ue">
          Done
        </button>
      </div>
    </form>;
}